import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=479c9440"
import script from "./reportTable.vue?vue&type=script&lang=js"
export * from "./reportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports